var fileref = document.createElement("link");
fileref.setAttribute("rel", "stylesheet");
fileref.setAttribute("type", "text/css");
fileref.setAttribute("href", blogfonts);
document.getElementsByTagName("head")[0].appendChild(fileref);


var articleimg = $('.insight-article-details img');
window.addEventListener("load", (event) => {
    setTimeout(() => {
        articleimg.addClass('load-article-img');
      }, "500");

      articleimg.addClass('fully-loaded');
      
});


$(window).scroll(function (event) {
    var scrollpos = $(window).scrollTop();
    var opacityadjust = scrollpos / 600;
    var scrolladjust = scrollpos / 2;
    var imgstyle = {
        transform: `translateY(-${scrolladjust}px)`,
        opacity: `${1 - opacityadjust}`
      };
    $(articleimg).css(imgstyle);

});
